import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import * as ssm from '@aws-cdk/aws-ssm';
import { SSM } from 'aws-sdk';



if (environment.production) {
  enableProdMode();
}

//Default main.ts
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// Retrieves the apiUrl from AWS Parameter store
// Use this for testing only. 
// The REGION, Access key, Secret Key are needed only if the task def role does not have the right permissions 
// var ssm = new SSM({
//   region: REGION,
//   accessKeyId: AWS_ACCESS_KEY_ID,
//   secretAccessKey: AWS_SECRET_ACCESS_KEY
// });
// var params = {
//   Name: 'API_URL', /* required */
//   WithDecryption: true || false
// };
// ssm.getParameter(params, function (err, data) {
//   if (err) console.log("ERROR", err, err.stack); // an error occurred
//   else {
//     console.log("Data", data); // successful response
//     environment.apiUrl = data.Parameter.Value
//     platformBrowserDynamic().bootstrapModule(AppModule)
//       .then(() => {
//         console.log("LOADED DOM")
//       })
//       .catch(err => console.error(err));
//   }
// });

//Un-comment below code for State of Florida
/*
const endpoint = ""
try {
  //var cookieData = window.parent.document.cookie
  var cookieData = null
  console.log("GET AUTH DETAILS")
  if (!cookieData) {
    cookieData = document.cookie
  }
  console.log("iplatent", cookieData)
  if (cookieData.includes("iPlanetDirectoryPro")) {
    var token = cookieData.split("iPlanetDirectoryPro=")[1].trim()

    getUsername(token).then(function () {
      getGroups(token).then(function () {
        platformBrowserDynamic().bootstrapModule(AppModule)
          .catch(err => {
            alert("Unable to intialize DocuEdge application. Please contact your administrator")
            console.error(err)
          });
      }).catch(function(){
        alert("Unable to fetch user groups. Please contact your administrator")
      })
    }).catch(function(){
      alert("Unable to fetch user details. Please contact your administrator")
    })
  } else {
    alert("Unable to load the application")
    window.close()
  }
} catch (err) {
  console.error("Error", err)
  alert("An unexpected error occured. Please try again")
  window.close()
}

async function getUsername(token) {
  var bearerToken = "Bearer " + token
  const header = {
    "Authorization": bearerToken
  }
  return new Promise<void>(async function (resolve, reject) {
    const response = await fetch(endpoint + `user/name`, { headers: header })
    const data = await response.json()
    if (response.status == 200) {
      var currentUserObject = {
        username: data.toString(),
        token: token
      }
      localStorage.setItem("currentUser", JSON.stringify(currentUserObject))
      resolve()
    } else {
      reject()
    }
  })
}

async function getGroups(token) {
  var bearerToken = "Bearer " + token
  const header = {
    "Authorization": bearerToken
  }
  return new Promise<void>(async function (resolve, reject) {
    const response = await fetch(endpoint + `usergroups/user`, { headers: header })
    const data = await response.json()
    console.log("Response", response)
    if (response.status == 200) {
      localStorage.setItem('userGroups', JSON.stringify(data))
      resolve()
    } else {
      reject()
    }
  })
}*/